import { render, staticRenderFns } from "./NuevasAltasComponent.vue?vue&type=template&id=431d71d2&scoped=true"
import script from "./NuevasAltasComponent.vue?vue&type=script&lang=js"
export * from "./NuevasAltasComponent.vue?vue&type=script&lang=js"
import style0 from "./NuevasAltasComponent.vue?vue&type=style&index=0&id=431d71d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431d71d2",
  null
  
)

export default component.exports